export const DEVICE_STATISTICS_KEY = 'device-statistics';
export const ORGANIZATION_MEMBER_LIST_KEY = 'fleet-members-list';
export const ORGANIZATION_MEMBER_KEY = 'fleet-member';
export const DISCHARGE_REASONS_KEY = 'discharge-reasons';
export const DISENGAGED_MEMBERS_KEY = 'disengaged-members';
export const CHECKIN_MEMBERS_KEY = 'checkin-members';
export const AI_INSIGHTS_KEY = 'ai-insights';
export const AI_INSIGHT_FEEDBACK_KEY = 'ai-insight-feedback';
export const CARE_MANAGERS_KEY = 'care-managers';
export const CUSTOM_DEMOGRAPHICS_KEY = 'member-custom-demographics';
